import React from 'react';
import CSVComponent from '../../components/CSVComponent';
import asbestosResultsTemplate from '../components/AsbestosResultsParserComponent';
// import leadResultsTemplate from '../components/LeadResultsParserComponent';
import eventsTemplate from '../components/EventsParserComponent';
import DependenciesComponent from '../../components/DependenciesComponent';

function CSVPage(props){
	
	const templates = {
		"Asbestos and SMF Results": asbestosResultsTemplate,
		"Events": eventsTemplate,
	};

	return (
		<DependenciesComponent mode="block" dependencies={["events","samples"]} {...props}>
			<CSVComponent templates={templates}  {...props}/>
		</DependenciesComponent>
	);
}

export default CSVPage;
